export const STORAGE_LAST_CLICKED_PRODUCT = "prv_cl_prdct";
export const STORAGE_LAST_CATEGORY = "prv_cat";
export const STORAGE_DELIVERY_ZIP = "dlv_zip";
export const STORAGE_DELIVERY_HOUSENUMBER = "dlv_hnr";
export const STORAGE_DELIVERY_HOUSENUMBER_ADDITION = "dlv_had";
export const STORAGE_DELIVERY_COUNTRY = "dlv_cnt";
export const STORAGE_DELIVERY_STREET = "dlv_str";
export const STORAGE_DELIVERY_CITY = "dlv_cty";
